import { ChevronLeft, ChevronRight } from "lucide-react";
import { formatRange, addDays, toISO, startOfWeek } from "@/components/operators/matrixDateUtils";

export function MatrixToolbar({ weekStart, setWeekStart, totalEvents, totalRows }) {
  const sundayOfWeek = addDays(weekStart, 6);
  const isCurrentWeek = toISO(weekStart) === toISO(startOfWeek(new Date()));
  const goPrev = () => setWeekStart(addDays(weekStart, -7));
  const goNext = () => setWeekStart(addDays(weekStart, 7));
  const goToday = () => setWeekStart(startOfWeek(new Date()));

  return (
    <div className="flex items-center justify-between gap-2 flex-wrap">
      <div className="flex items-center gap-2">
        <button
          onClick={goPrev}
          data-testid="matrix-prev-week"
          className="p-1.5 rounded-sm border border-zinc-200 bg-white hover:bg-zinc-50 transition"
          title="Settimana precedente"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>
        <div className="text-sm font-mono px-3" data-testid="matrix-week-range">
          {formatRange(weekStart, sundayOfWeek)}
        </div>
        <button
          onClick={goNext}
          data-testid="matrix-next-week"
          className="p-1.5 rounded-sm border border-zinc-200 bg-white hover:bg-zinc-50 transition"
          title="Settimana successiva"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
        {!isCurrentWeek && (
          <button
            onClick={goToday}
            data-testid="matrix-today"
            className="ml-2 px-2 py-1 text-xs rounded-sm border border-zinc-200 bg-white hover:bg-blue-50/50 hover:border-[#002FA7] transition"
          >
            Oggi
          </button>
        )}
      </div>
      <div className="text-xs text-zinc-500" data-testid="matrix-week-total">
        <span className="font-mono font-semibold text-zinc-900">{totalEvents}</span> eventi totali ·{" "}
        <span className="font-mono font-semibold text-zinc-900">{totalRows}</span> operatori
      </div>
    </div>
  );
}

export function MatrixLegend() {
  return (
    <div className="flex flex-wrap items-center gap-3 text-[10px] text-zinc-500">
      <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-sm" style={{ background: "#002FA7" }} /> Ritiro</span>
      <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-sm" style={{ background: "#059669" }} /> Consegna</span>
      <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-sm" style={{ background: "#7C3AED" }} /> Inventario</span>
      <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-sm" style={{ background: "#D97706" }} /> Inv. Riconsegna</span>
      <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-sm" style={{ background: "#EAB308" }} /> Riconsegna prevista</span>
      <span className="text-zinc-400">·</span>
      <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-sm bg-amber-50 border border-amber-300" /> 3 lavori</span>
      <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-sm bg-red-50 border border-red-300" /> ≥4 lavori</span>
      <span className="text-zinc-400">·</span>
      <span>Trascina un chip su un altro giorno per ricalendarizzare</span>
    </div>
  );
}
